import React from "react";

const CompanyDetailsModal = ({
  handleChange,
  setimgfile,
  handleAddDataSubmit,
  formRef,
  setRowAddData,
  rowAddData,
}) => {
  function resetFileds() {
    setRowAddData({
      company_name: "",
      type: "",
      location: "",
    });
  }
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Company
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Company</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Company_Name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="Company_Name"
                              placeholder="Company Name"
                              value={rowAddData?.company_name}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="type">Type</label>
                            <input
                              type="text"
                              className="form-control"
                              name="type"
                              id="type"
                              placeholder="Type"
                              value={rowAddData?.type}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              placeholder="Location"
                              value={rowAddData?.location}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyDetailsModal;
